<nz-result nzStatus="404" nzTitle="404" nzSubTitle="Sorry, the page you visited does not exist.">
  <div nz-result-extra>
    <button [routerLink]="['/']" nz-button nzType="primary">Back Home</button>
  </div>
</nz-result>
